<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mpmz87/tc-custom/9783987444593.jpg?1704425250800" alt="This image is the cover for the book Tiergeschichten, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tiergeschichten, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Jakob Krakel-Krakel, Das patentierte Krokodil, Lups, Balduin Brummsel oder Jeremias Kugelkopf - wer hat nicht schon einmal von ihnen gehört oder gelesen. Die Tiergeschichten sind von unvergeßlicher Komik, der die tiefere Bedeutung nicht fehlt. Manfred Kybers Tiergeschichten sind moderne Fabeln, seine Märchen sind Geschichten für Erwachsenen, voll echtem Märchenton, in denen behutsam und ohne falsche Ambition von den großen Fragen der Welt und des Menschen die Rede ist. (Amazon)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Manfred Kyber
      </h2>
      
      <p class="authorDescription body article">Manfred Kyber (* 18. Februarjul. / 1. März 1880greg. in Riga, damals Russisches Kaiserreich; † 10. März 1933 in Löwenstein) war ein deutscher Schriftsteller, Theaterkritiker, Dramatiker, Lyriker und Übersetzer deutschbaltischer Herkunft, der vor allem durch seine ungewöhnlichen Tiergeschichten bekannt geworden ist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?707efe96